import axiosInstance from "api/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
export const requestChangePhoneOtp = async (data, accessToken) => {
    try {
        const response = await axiosInstance.post(
            "/auth/change-phone/request-otp",
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
};

/**
 * =========================================================
 * مرحله ۲:
 * تایید OTP و تغییر شماره موبایل
 *
 * POST /auth/change-phone/verify
 * =========================================================
 */
export const verifyChangePhone = async (data, accessToken) => {
    try {
        const response = await axiosInstance.post(
            "/auth/change-phone/verify",
            data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {

        throw error?.response?.data || error;
    }
};